<div class="bg-gray-100 rounded-2xl rounded-tl-md p-5">
    <!-- Header -->
    <div class="flex items-center mb-3">
        <span class="text-2xl mr-2">{{ getIcon() }}</span>
        <span class="text-[24px] font-remote font-[600] text-gray-900">{{ title }}</span>
    </div>

    <!-- Multi Column Data -->
    <div class="flex flex-wrap gap-3 mb-3">
        <ng-container *ngFor="let column of getColumns()">
            <div class="flex-1 min-w-[80px] bg-white bg-opacity-60 rounded-lg p-3 text-center">
                <div class="text-[10px] font-inter text-gray-500 uppercase tracking-wide mb-1">
                    {{ column.label }}
                </div>

                <!-- Avatar -->
                <ng-container *ngIf="isAvatar(column.key)">
                    <div class="flex justify-center">
                        <spotlight-avatar
                            [data]="data"
                            size="md"
                            rounded="full">
                        </spotlight-avatar>
                    </div>
                </ng-container>

                <!-- Regular Value -->
                <ng-container *ngIf="!isAvatar(column.key)">
                    <div class="text-[18px] font-remote font-[600] text-gray-800">
                        {{ formatColumnValue(column.value, column.key) }}
                    </div>
                </ng-container>
            </div>
        </ng-container>
    </div>

    <!-- Description -->
    <p class="text-[14px] font-inter text-gray-600 leading-relaxed">
        {{ description }}
    </p>

    <!-- Footer -->
    <spotlight-response-footer
        [executionTimeMs]="executionTimeMs">
    </spotlight-response-footer>
</div>
